import { gql } from "@apollo/client"

const EXTEND_SESSION_MUTATION = gql`
  mutation($input: ExtendSessionInput!) {
    extendSession(input: $input) {
      id
      title
      starts_at
      ends_at
      slot_duration
      slot_gap
      guardian_restriction
    }
  }
`

export { EXTEND_SESSION_MUTATION }